import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { Project } from "@overmap-ai/common"
import { memo } from "react"

import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface ProjectMultiSelectGroupProps extends MenuMultiSelectGroupProps<Project> {
	projects: Project[]
}

export const ProjectMultiSelectGroup = memo<ProjectMultiSelectGroupProps>((props) => {
	const { ref, projects, ...rest } = props

	return (
		<Menu.MultiSelectGroup<Project> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{projects.map((project) => (
				<MultiSelectItemTemplate<Project> key={project.uuid} value={project}>
					<Text className="truncate">{project.name}</Text>
				</MultiSelectItemTemplate>
			))}
		</Menu.MultiSelectGroup>
	)
})
ProjectMultiSelectGroup.displayName = "ProjectMultiSelectGroup"
